<div class="d-flex flex-column gap-3 mt-3 questionnaire-field-spacer">
    <p-inputnumber  *ngIf="props.hasInput"
                    class="slider-input"
                    [min]="props.minValue"
                    [max]="props.maxValue"
                    mode="decimal"
                    [formControl]="formControl"></p-inputnumber>
    <p-slider [formControl]="formControl" class="d-block ms-2" [step]="props.step" [min]="props.minValue" [max]="props.maxValue" />
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
